import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import ExtractForm from "../../../components/data_products/extracts/ExtractForm";
import {useDifactoBucket} from "../../../components/utils";
import { useCreateExtractMutation, useGetExtractAggregationOptionsQuery } from "../../../api/extractApiSlice";
import {useGetAudiencesQuery} from "../../../api/audienceApiSlice";

function NewExtract(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const bucket = useDifactoBucket();
  const { data: aggregationOptions = [] } = useGetExtractAggregationOptionsQuery()
  const { data: audiences = [] } = useGetAudiencesQuery()

  const goToExtract = (data) => history.push(`/extracts/${data.key}`)

  const [newExtract] = useCreateExtractMutation()

  const submitProps = {
    handleSubmit: async (data) => {
      newExtract(data).unwrap()
        .then(goToExtract)
        .catch(error => {})
    },
    errors: {}
  }

  return (
    <>
      <Title
        main={t("menu.extracts")}
        sub={t("new")}
        group={false}
        backPath="/extracts">
        <FormButton submit {...submitButtonProps}/>
      </Title>
      <ExtractForm
        bucket={bucket}
        {...submitProps}
        setSubmitButtonProps={setSubmitButtonProps}
        audiences={audiences}
        aggregationOptions={aggregationOptions}/>
    </>
  )
}

export default NewExtract
